export default "__VITE_ASSET__58aa8d5a__"